import PopupsFullPageContainer from "components/PopupsFullPageContainer";
import { Button, Heading, Text } from "iparque-components";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const StyledPopupsFullPageContainer = styled(PopupsFullPageContainer)`
  padding-bottom: 0;

  .city-animation {
    width: 40%;
    transform: translate(0, 8%);

    @media (max-width: ${breakpoints.lg}) {
      width: 50%;
    }

    @media (max-width: ${breakpoints.sm}) {
      width: 70%;
    }
  }
`;

export const TextContainer = styled.div`
  width: 50%;
  margin-bottom: 50px;

  @media (max-width: ${breakpoints.lg}) {
    width: 100%;
    margin-top: 35vh;
  }

  @media (max-width: ${breakpoints.sm}) {
    width: 100%;
    margin-top: 32vh;
  }
`;

export const StyledHeading = styled(Heading)`
  line-height: 1em;
  padding-bottom: 25px;
`;

export const StyledText = styled(Text).attrs({
  variant: "body5",
  color: "quintenary",
})`
  p {
    margin-bottom: 20px;

    :last-child {
      margin-bottom: 40px;
    }
  }
`;

export const VideoButton = styled(Button)`
  margin-top: 40px;
  float: right;
  background-color: ${({ theme }) => theme.colors.street};
`;
